import { highlightSearchText } from "@/utils/textHelpers";

function cleanPhoneNumber(match: string) {
    // Извлекаем только цифры
    const digits = match.replace(/[^\d+]/g, '');
    // Проверяем длину
    if (digits.length < 6) return null; // Не номер
    return digits;
}
const PHONE_REG_EXP = /([+]?[0-9\s-]*(?:\([0-9\s.-]+\))?[-.\s0-9]*[0-9])(?![0-9\s.-]*@)/gi
const EMAIL_REG_EXP = /[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*/gi
const URL_REG_EXP = /(?:(?:https?|ftp):\/\/)?(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}(?::\d{1,5})?(?:\/[^\s?#]*)?(?:\?[^\s#]*)?(?:#[^\s]*)?|(?:(?:https?|ftp):\/\/)?\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3}(?::\d{1,5})?(?:\/[^\s?#]*)?|localhost(?::\d{1,5})?(?:\/[^\s?#]*)?/gi;

const COMBINED_REG_EXP = new RegExp(
    `(${PHONE_REG_EXP.source})|(${EMAIL_REG_EXP.source})|(${URL_REG_EXP.source})`,
    'gi'
);

export function splitTextByPhoneNumbers(input: string, searchText: string) {
    const replacedText = input.replace(/<span class="searchedText">|<\/span>/g, '')
    const result = [];
    let lastIndex = 0;

    const combinedRegExp = COMBINED_REG_EXP;
    combinedRegExp.lastIndex = 0;

    let match: RegExpExecArray | null;

    while ((match = combinedRegExp.exec(replacedText)) !== null) {
        const start = match.index;
        const end = combinedRegExp.lastIndex;
        const matchedText = match[0];

        // Тип определяется по тому, какая альтернатива в combinedRegExp реально сматчилась.
        // match[1] — PHONE-ветка (внешняя обёртка вокруг PHONE_REG_EXP),
        // match[3] — EMAIL-ветка, match[4] — URL-ветка
        let isPhone = false;
        let isEmail = false;
        let isUrl = false;
        if (match[1] !== undefined) {
            isPhone = !!cleanPhoneNumber(matchedText);
        } else if (match[3] !== undefined) {
            isEmail = /@/.test(matchedText);
        } else if (match[4] !== undefined) {
            isUrl = isValidUrl(matchedText);
        }

        if (start > lastIndex) {
            const textBefore = replacedText.substring(lastIndex, start);
            if (textBefore) {
                if (result[result.length - 1] &&
                    !result[result.length - 1].isPhone &&
                    !result[result.length - 1].isEmail &&
                    !result[result.length - 1].isUrl) {
                    result[result.length - 1].text += textBefore;
                } else {
                    result.push({
                        text: textBefore,
                        isPhone: false,
                        isEmail: false,
                        isUrl: false
                    });
                }
            }
        }

        const highlightedText = searchText
            ? highlightSearchText(searchText, matchedText)
            : matchedText;

        result.push({
            text: highlightedText,
            isPhone: isPhone,
            isEmail: isEmail,
            isUrl: isUrl
        });

        lastIndex = end;
    }

    if (lastIndex < replacedText.length) {
        const remainingText = replacedText.substring(lastIndex);
        if (remainingText) {
            if (result[result.length - 1] &&
                !result[result.length - 1]?.isPhone &&
                !result[result.length - 1]?.isEmail &&
                !result[result.length - 1]?.isUrl) {
                result[result.length - 1].text += remainingText;
            } else {
                result.push({
                    text: remainingText,
                    isPhone: false,
                    isEmail: false,
                    isUrl: false
                });
            }
        }
    }

    if (result.length === 0) {
        result.push({
            text: replacedText,
            isPhone: false,
            isEmail: false,
            isUrl: false
        });
    }

    return result;
}

// Вспомогательная функция для валидации URL
function isValidUrl(text: string): boolean {
    try {
        let urlText = text;
        if (!/^(https?|ftp):\/\//i.test(text)) {
            urlText = 'http://' + text;
        }

        const url = new URL(urlText);

        const domainParts = url.hostname.split('.');
        if (domainParts.length < 2) return false;

        const tld = domainParts[domainParts.length - 1].toLowerCase();
        const validTlds = [
            'com', 'org', 'net', 'edu', 'gov', 'mil', 'io', 'co',
            'ai', 'ru', 'ua', 'by', 'kz', 'uk', 'de', 'fr', 'es',
            'info', 'biz', 'me', 'tv', 'app', 'dev', 'online'
        ];

        if (tld.length < 2 || (!validTlds.includes(tld) && !/^[a-z]{2,}$/.test(tld))) {
            return false;
        }

        if (!/^[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?)*$/.test(url.hostname)) {
            return false;
        }

        return true;
    } catch (error) {
        return false;
    }
}
